import type { Nullable } from '../../../../../models';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatPacing = (value: Nullable<number>): string => (!value ? '' : `${formatter.format(value)}%`);
